import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { Slot } from '../types/slot';
import { useSiteSettings } from '../contexts/SiteSettingsContext';
import { getCasinosForSlot } from '../utils/slots';
import { DemoFrame } from './DemoFrame';
import { RealMoneyButton } from './RealMoneyButton';
export function DemoModal({
  slot,
  onClose
}: {
  slot: Slot | null;
  onClose: () => void;
}) {
  const {
    showRealMoneyCtas
  } = useSiteSettings();
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!slot) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [slot, onClose]);
  const casino = slot ? getCasinosForSlot(slot)[0] : undefined;
  return <AnimatePresence data-id="element-39" data-mp="30k3tbj66df9">
      {slot && <motion.div className="fixed inset-0 z-50 flex items-end justify-center bg-ink/70 p-0 sm:items-center sm:p-6" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onClick={onClose} data-id="element-40" data-mp="31lnu5i5ya94">
          <motion.div role="dialog" aria-modal="true" aria-labelledby="demo-title" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={e => e.stopPropagation()} className="w-full max-w-4xl overflow-hidden rounded-t-2xl bg-surface sm:rounded-2xl" data-id="element-41" data-mp="h1mnxiqltdnj">
            <div className="flex items-center justify-between gap-4 border-b border-line px-5 py-3" data-id="element-42" data-mp="2wsr3pznskltd">
              <div className="min-w-0" data-id="element-43" data-mp="137xi3o2fal5y">
                <h2 id="demo-title" className="truncate font-serif text-lg font-semibold" data-id="element-44" data-mp="y9w3pgfxza0t">
                  {slot.name} <span className="font-sans text-sm font-normal text-muted" data-id="element-45" data-mp="tidzmjimgtbm">· gratis demo</span>
                </h2>
              </div>
              <button ref={closeRef} type="button" onClick={onClose} className="rounded-md p-2 text-muted hover:bg-paper hover:text-ink" aria-label="Demo sluiten" data-id="element-46" data-mp="oj1b7uc3re6x">
                <XIcon className="h-5 w-5" data-id="element-47" data-mp="ajtfjbf5eo7h" />
              </button>
            </div>

            <div className="p-3 sm:p-4" data-id="element-48" data-mp="5kyl1c7tjb7j">
              <DemoFrame slot={slot} autoStart data-id="element-49" data-mp="5m04a3yzn40c" />
            </div>

            <div className="flex flex-col gap-4 border-t border-line bg-paper px-5 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-50" data-mp="24xu8xgrxij06">
              {showRealMoneyCtas && casino ? <>
                  <div className="min-w-0" data-id="element-51" data-mp="27j235064r2j1">
                    <p className="text-sm font-semibold" data-id="element-52" data-mp="27i8q5hgkvgsg">Klaar om met echt geld te spelen?</p>
                    <p className="text-sm text-muted" data-id="element-53" data-mp="2cg0ujayesvdj">
                      {casino.name}: <span className="font-medium text-ink" data-id="element-54" data-mp="2h824urc0oc0x">{casino.bonus}</span> {casino.bonusDetail.toLowerCase()}
                    </p>
                    <p className="mt-1 text-[11px] text-muted" data-id="element-55" data-mp="2m6n6mv6x33rh">Advertentie · 18+ · Voorwaarden van toepassing</p>
                  </div>
                  <div className="flex shrink-0 gap-2" data-id="element-56" data-mp="1tihf9plcygio">
                    <Link to={`/slots/${slot.slug}`} className="inline-flex h-11 items-center rounded-lg border border-line bg-surface px-4 text-sm font-semibold hover:border-ink/30" data-id="element-57" data-mp="1tizl9dxto93s">
                      Lees review
                    </Link>
                    <RealMoneyButton slot={slot} label={`Speel bij ${casino.name.split(' ')[0]}`} data-id="element-58" data-mp="39z3ketjmg9kz" />
                  </div>
                </> : <>
                  <p className="text-sm text-muted" data-id="element-59" data-mp="3chxgtwbrd2sl">Benieuwd hoe {slot.name} scoort op RTP, volatiliteit en features?</p>
                  <Link to={`/slots/${slot.slug}`} className="inline-flex h-11 items-center justify-center rounded-lg bg-fern px-5 text-sm font-semibold text-white hover:bg-fern-dark" data-id="element-60" data-mp="38i6lrgf780i9">
                    Lees de review
                  </Link>
                </>}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}